<nav class="menuFooter" aria-label="Menu mobile">
  <button
    type="button"
    class="menu-toggle"
    [class.is-active]="selectedMenu === 'home'"
    [attr.aria-current]="selectedMenu === 'home' ? 'page' : null"
    routerLink="/{{ locale }}"
    (click)="navigateTo('home')"
  >
    <div class="menuIconText">
      <mat-icon aria-hidden="true">home</mat-icon>
      <span translate>raccourcis.accueil</span>
    </div>
  </button>

  <button
    type="button"
    class="menu-toggle"
    [class.is-active]="selectedMenu === 'itineraires'"
    [attr.aria-current]="selectedMenu === 'itineraires' ? 'page' : null"
    routerLink="{{ 'ROUTES.itineraires' | translate }}"
    (click)="navigateTo('itineraires')"
  >
    <div class="menuIconText">
      <mat-icon aria-hidden="true">transfer_within_a_station</mat-icon>
      <span translate>menu.itineraires</span>
    </div>
  </button>

  <button
    type="button"
    class="menu-toggle"
    [class.is-active]="selectedMenu === 'mon-compte'"
    [attr.aria-current]="selectedMenu === 'mon-compte' ? 'page' : null"
    routerLink="{{ 'ROUTES.mon-compte' | translate }}"
    (click)="navigateTo('mon-compte')"
  >
    <div class="menuIconText">
      <mat-icon aria-hidden="true">person</mat-icon>
      <span translate>menu.monEspace</span>
    </div>
  </button>

  <button
    type="button"
    class="menu-toggle"
    [class.is-active]="selectedMenu === 'search'"
    (click)="showSearchModal()"
  >
    <div class="menuIconText">
      <mat-icon aria-hidden="true">search</mat-icon>
      <span translate>raccourcis.rechercher</span>
    </div>
  </button>
</nav>
